import type React from 'react';
import { createContext } from 'react';

import { noop } from 'lodash';

import type { DialogProps } from '../Dialog/Dialog';
import type { CloseDialogFn, DialogComponentProps, OpenDialogFn } from './DialogProvider';

export type DialogComponent<T = DialogProps> = React.ComponentType<T>;

export type DialogContextState = {
  props?: DialogComponentProps<DialogProps>;
  component?: DialogComponent<DialogComponentProps<DialogProps>> | null;
  isOpen?: boolean;
};

export interface DialogContextValues extends DialogContextState {
  openDialog: OpenDialogFn;
  closeDialog: CloseDialogFn;
}

export const DialogContext = createContext<DialogContextValues>({
  openDialog: noop,
  closeDialog: noop,
});
